import { useMemo } from 'react';
import type { SidebarBadge } from './useSetupBadges';

/** Badges do menu professor — sem ícones de homologação (✓) no sidebar. */
export function useProfessorNavBadges(): Record<string, SidebarBadge> {
  return useMemo(() => ({}), []);
}
